__turbopack_context__.v({
  "table": "r9oxzG_table",
});
